var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"base-button",class:{
    '_not-active': _vm.viewType === 'not-active',
    '_border-gray': _vm.viewType === 'border-gray',
    '_color-fill-blue': _vm.viewType === 'color-fill-blue',
    '_color-fill-gray': _vm.viewType === 'color-fill-gray',
    '_color-fill-pink': _vm.viewType === 'color-fill-pink',
    '_color-border-blue': _vm.viewType === 'color-border-blue',
    _disabled: _vm.disabled,
  }},[_vm._t("default",[_vm._v("Button")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }